import React from 'react';
import { CheckCircle2, Clock, AlertTriangle, Calendar, Activity, Plus, UserPlus } from 'lucide-react';
import './Dashboard.css';

const StatCard = ({ icon: Icon, label, value, color, sub }) => (
  <div className={`stat-card stat-${color}`}>
    <div className="stat-icon-wrap">
      <Icon size={18} />
    </div>
    <div className="stat-body">
      <span className="stat-value">{value}</span>
      <span className="stat-label">{label}</span>
      {sub && <span className="stat-sub">{sub}</span>}
    </div>
  </div>
);

export default function Dashboard({ stats, onCreate, currentUser, onAddUser }) {
  const pct = stats.total > 0 ? Math.round((stats.completed / stats.total) * 100) : 0;

  return (
    <section className="dashboard fade-in">
      <div className="dashboard-header">
        <div>
          <h2 className="dashboard-title">Overview</h2>
          <p className="dashboard-date">
            {new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}
          </p>
        </div>
        <div className="dashboard-header-right">
          <div className="progress-wrap">
            <div className="progress-label">
              <span>{pct}% complete</span>
              <span className="progress-fraction">{stats.completed}/{stats.total}</span>
            </div>
            <div className="progress-bar">
              <div className="progress-fill" style={{ width: `${pct}%` }} />
            </div>
          </div>
          <div className="dashboard-actions">
            {currentUser?.role === 'admin' && onAddUser && (
              <button
                type="button"
                className="dashboard-add-user-btn"
                onClick={onAddUser}
                title="Add new user"
                aria-label="Add new user"
              >
                <UserPlus size={18} />
                <span>Add User</span>
              </button>
            )}
            {onCreate && (
              <button
                type="button"
                className="dashboard-create-btn"
                onClick={onCreate}
                title="Create new chore"
                aria-label="Create new chore"
              >
                <Plus size={18} />
                <span>New chore</span>
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="stats-grid">
        <StatCard icon={Activity} label="Total" value={stats.total} color="default" />
        <StatCard icon={Clock} label="Pending" value={stats.pending} color="blue" />
        <StatCard icon={CheckCircle2} label="Completed" value={stats.completed} color="green" />
        <StatCard icon={AlertTriangle} label="High Priority" value={stats.highPriority} color="red" sub="pending" />
        <StatCard icon={Calendar} label="Due Today" value={stats.dueToday} color="yellow" />
        {onCreate && (
          <button
            type="button"
            className="stat-card stat-create"
            onClick={onCreate}
            aria-label="Create new chore"
          >
            <div className="stat-icon-wrap">
              <Plus size={18} />
            </div>
            <div className="stat-body">
              <span className="stat-value stat-create-value">+</span>
              <span className="stat-label">New chore</span>
            </div>
          </button>
        )}
      </div>
    </section>
  );
}
